import ProductsError from './ProductsError.js'

export default class InvalidProductError extends ProductsError {}
